import { cva, type VariantProps } from "cva";

export const buttonStyles = cva({
  base: [
    "cursor-pointer flex items-center justify-center gap-x-4 font-ginto font-medium leading-100 transition-colors duration-150 ease [&>svg]:fill-current",
  ],
  variants: {
    variant: {
      primary: "border-1",
      secondary: "border-1",
      media: "border-1 backdrop-blur-button",
    },
    tone: {
      default: "",
      neutral: "",
    },
    size: {
      xs: "px-12 text-ginto-14 rounded-xs py-8",
      s: "px-16 text-ginto-14 rounded-sm py-10",
      m: "px-24 text-ginto-16 rounded-default py-14",
      l: "px-32 text-ginto-18 rounded-md py-16",
    },
    disabled: {
      true: "cursor-not-allowed",
      false: "",
    },
  },
  compoundVariants: [
    {
      variant: ["primary", "secondary"],
      tone: "default",
      disabled: false,
      class: "outline-border focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-border",
    },
    {
      variant: ["primary", "secondary"],
      tone: "neutral",
      disabled: false,
      class: "outline-border focus-visible:outline-4 focus-visible:outline-offset-0 focus-visible:outline-chalk-600",
    },
    {
      variant: "media",
      tone: ["default", "neutral"],
      disabled: false,
      class: "outline-border focus-visible:outline-4 focus-visible:outline-offset-0 focus-visible:outline-ink-600",
    },
    {
      variant: "primary",
      disabled: false,
      tone: "default",
      class: [
        "bg-brand-primary text-content-light border-transparent hover:bg-brand-primary-hover active:bg-brand-primary",
        "sparks:hover:bg-brand-primary",
        "tutor:bg-emerald-300 tutor:text-content-primary tutor:border-content-primary tutor:border-2 tutor:hover:bg-emerald-400 tutor:active:bg-emerald-300",
        "islands:bg-amber-400 islands:text-content-primary islands:hover:bg-amber-400 islands:active:bg-amber-400",
      ],
    },
    {
      variant: "primary",
      disabled: false,
      tone: "neutral",
      class: ["bg-surface text-content-primary"],
    },
    {
      variant: "secondary",
      tone: "default",
      disabled: false,
      class: "bg-transparent text-content-primary border-border-decorative hover:bg-ink-100 active:bg-transparent ",
    },
    {
      variant: "secondary",
      tone: "neutral",
      disabled: false,
      class: "bg-transparent text-content-light border-surface hover:bg-ink-200 active:bg-transparent",
    },
    {
      variant: "media",
      disabled: false,
      class: "bg-ink-500 text-white border-transparent hover:bg-ink-600 active:bg-ink-500",
    },
    {
      variant: "primary",
      disabled: true,
      class: "bg-neutral-200 text-neutral-600 border-transparent",
    },
    {
      variant: "secondary",
      disabled: true,
      class: "bg-neutral-200 text-neutral-600 border-transparent",
    },
    {
      variant: "media",
      disabled: true,
      class: "bg-neutral-200 text-neutral-600 border-transparent",
    },
    {
      size: ["xs", "s"],
      class: "[&>svg]:w-18 [&>svg]:h-18",
    },
    {
      size: ["m", "l"],
      class: "[&>svg]:w-24 [&>svg]:h-24",
    },
  ],
});

export type ButtonStylesProps = VariantProps<typeof buttonStyles>;
